import React, { Component } from 'react';
import Subscription from './Subscription';
import Counters from './Counters';
import Logout from './Logout';

export default class DashMain extends Component {
    constructor(props) {
        super(props);
        this.state = {counters:null, subscription:null};
    }

    componentDidMount() {
        this.updateCounters(this.props.app);
        this.updateSubscription(this.props.app);
    }

    componentWillReceiveProps(nextProps) {
        this.updateCounters(nextProps.app);
        this.updateSubscription(nextProps.app);
    }

    async updateCounters(app) {
        try {
            const counters = await app.counters();
            this.setState({counters});
        } catch(err) {
            this.setState({counters:null});
        }
    }

    async updateSubscription(app) {
        try {
            const subscription = await app.subscription();
            this.setState({subscription});
        } catch(err) {
            this.setState({subscription:null});
        }
    }

    render() {
        const account = this.props.account;
        const onSubChanged = () => this.updateSubscription(this.props.app);
        return <div id="dash">
            <DashHeader account={account} onLogOut={() => this.props.app.logOut()} />
            <main>
                <section>
                    <FirstSteps account={account} />
                    {account.firstImage ? <Counters counters={this.state.counters} /> : null}
                </section>
                <section>
                    <Subscription subscription={this.state.subscription} onSubChanged={onSubChanged} app={this.props.app} />
                </section>

                <Programmatic account={account} />

            </main>
        </div>;
    }
}

function DashHeader(props) {
    const account = props.account;
    if (!account || !account.email) throw Error("Missing account data");
    const name = account.name || account.email.replace(/@.*$/,'');
    return <div className="user-header">
        <div className="api-user">API <a href={`https://imageoptim.com/api/username?username=${account.key}#get`}>username</a> <strong>{account.key}</strong></div>
        <div className="user" title={account.email}>
            <img alt="" src={account.avatar_url} width="40" /> {name} <Logout onLogOut={props.onLogOut} />
        </div>
    </div>
}

function Programmatic(props) {
    const account = props.account;
    if (account.adminAPIKey) {
        return <section id="adminapikey">
            <details><summary><h3>Sharing dashboard data with other applications</h3></summary>
            <p><code>{account.key}</code> <code>{account.adminAPIKey}</code> is your username and key for giving applications access to usage information from this dashboard.
                Note that the key is needed only for programmatic access to usage data, and <em>not</em> for image processing. <a href="/api/dashkey">Dashboard API documentation</a>.</p>
        </details></section>;
    }
    return null;
}

function FirstSteps(props) {
    const acc = props.account;
    if (!acc.firstImage) {
        return <section className="top-message">
            <h3>Next step</h3>
            {acc.firstError ? <p>Need help integrating? <a href="mailto:kornel@imageoptim.com">Contact support — we&rsquo;re happy to help!</a></p> : null}
            <p>Integrate the API:</p>
            <ul>
                <li><a href="/api/get">with any web site by changing image URLs in HTML</a>,</li>
                <li><a href="/api/post">with site back-end by using HTTP API (advanced)</a>,</li>
                <li><a href="/api/start">using other options and plug-ins</a>.</li>
            </ul>
        </section>
    }
    return null;
}



// WEBPACK FOOTER //
// ./src/ui/DashMain.jsx